import styled from 'styled-components';

export const MySafetyBlockWrapper = styled.div(
  props => `
    width: 100%;
    background: ${props.theme.colors.white.base};
  `
);

export const MySafetyBlockInner = styled.div(
  props => `
    padding: ${props.theme.spacing.large.l30};
    @media only screen and (min-width:320px) and (max-width: 767px){
      padding: 0;
    }
    @media only screen and (min-width:768px) and (max-width: 1024px){
      padding: 0;
    }
  `
);

export const MySafetyHeadBlock = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    padding: 0;
    @media only screen and (min-width:320px) and (max-width: 767px){
      padding: ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l15} ;
    }
    @media only screen and (min-width:768px) and (max-width: 1024px){
      padding: ${props.theme.spacing.large.l30} 0 ${props.theme.spacing.large.l15} ;
    }
  `
)

export const BenefitHeader = styled.div(
  props => `
    font-size: 3.5rem;
    color: ${props.theme.colors.blue.dark};
    font-weight: ${props.theme.font.fontWeight.black};
    text-align: center;
    #mySafety {
      color: ${props.theme.colors.blue.base};
    }
    #safety {
      color: ${props.theme.colors.grey.base};
    }
    @media only screen and (min-width:320px) and (max-width: 767px){
      font-size: ${props.theme.font.large.font18};
    }
  `
);

export const BenefitSubHeader = styled.div(
  props => `
    font-size: ${props.theme.font.large.font18};
    font-weight: ${props.theme.font.fontWeight.normal};
    color: ${props.theme.colors.grey.base};
    line-height: 1.3;
    text-align: center;
    @media only screen and (min-width:320px) and (max-width: 767px){
      font-size: ${props.theme.font.base};
    }

  `
);

export const MySafetyBlock = styled.ul(
  props => `
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: ${props.theme.spacing.large.l50};

    li{
      display: flex;
      width: 27rem;
      border: 1px solid ${props.theme.colors.grey.lightd8};
      border-radius: ${props.theme.misc.borderRadius.base};
      flex-direction: column;
      margin: ${props.theme.spacing.base};
      padding: ${props.theme.spacing.base} ${props.theme.spacing.small.s5};
    }
    @media only screen and (min-width:320px) and (max-width: 767px){
      margin: ${props.theme.spacing.base} 0;
      width: 150rem;
      padding: 0 ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l15};
      li{
        width: 28rem;
        margin: 0;
        padding: ${props.theme.spacing.base} ${props.theme.spacing.small.s5};
        margin-right: ${props.theme.spacing.base};
      }
    }
    @media only screen and (min-width:768px) and (max-width: 1024px){
      margin: ${props.theme.spacing.base} 0;
      width: 150rem;
      padding: 0 ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l15};
      li{
        width: 28rem;
        margin: 0;
        padding: ${props.theme.spacing.base} ${props.theme.spacing.small.s5};
        margin-right: ${props.theme.spacing.base};
      }
    }
  `
);

export const MySafetyWrapper = styled.div(
  props => `
    width:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    @media only screen and (min-width: 320px) and (max-width: 767px){
      align-items: center;
      justify-content: flex-start;
      overflow: auto;
      ::-webkit-scrollbar { 
        display: none; 
      } 
    }
    @media only screen and (min-width: 768px) and (max-width: 1024px){
      align-items: center;
      justify-content: flex-start;
      overflow: auto;
      ::-webkit-scrollbar { 
        display: none; 
      } 
    }
  `
);

export const IconWrapper = styled.div(
  props => `
    width: 100%;
    display: flex;
    justify-content: center;
    padding: ${props.theme.spacing.small.s8};
  `
);

export const TextWrapper = styled.div(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.black.base};
    text-align: center;
    span {
      font-weight: ${props.theme.font.fontWeight.bold};
    }
    @media only screen and (min-width:320px) and (max-width: 767px){}
  `
);
